import LinearProgress from '@material-ui/core/LinearProgress';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import React from 'react';

export const AutoTable = React.forwardRef(({ loading, header, rows, emptyTitle }, ref) => {
	if (loading) {
		return (
			<LinearProgress />
		);
	}

	return (
		<Table ref={ref} size="small">
			<TableHead>
				<TableRow>
					{header && header.map(([key, title]) => <TableCell key={key}>{title}</TableCell>)}
				</TableRow>
			</TableHead>
			<TableBody>
				{rows?.length ? (
					rows.map((row, index) =>
						<TableRow key={row.id || index}>
							{header && header.map(([key]) => <TableCell key={key}>{row[key]}</TableCell>)}
						</TableRow>
					)
				) : (
					<TableRow>
						<TableCell colSpan={header ? header.length : 1} align="center">{emptyTitle}</TableCell>
					</TableRow>
				)}
			</TableBody>
		</Table>
	);
});
